import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks';
import { SpinnerComponent } from "../../../lib/spinner";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { removeCompanyCenter, setDeleteCompanyCenterStatus } from "../feature/companyCenter/slice";

interface Props {
    visible: boolean;
    onClose: () => void;
    id?: string;
}

export function DeleteCompanyCenterModal(props: Props) {
    const { visible, onClose, id } = props;
    const dispatch = useAppDispatch();
    const companyCenterState = useAppSelector(state => state.companyCenter);

    useEffect(() => {
        if (companyCenterState.deleteCompanyCenterStatus === 'successfully') {
            dispatch(setDeleteCompanyCenterStatus('idle'));
            onClose();
        }
    }, [companyCenterState.deleteCompanyCenterStatus, dispatch, onClose]);

    if (!visible) return null;

    const isLoading = companyCenterState.deleteCompanyCenterStatus === 'loading';

    return (
        <PopupForm title="Elimina centro aziendale" close={onClose}>
            <div className="p-6 bg-white flex flex-col gap-6">
                {
                    isLoading
                        ? <div className="flex justify-center py-2"><SpinnerComponent size={"small"} /></div>
                        : <p className="text-left text-md font-medium text-neutral-700">Sei sicuro di voler eliminare questo centro aziendale?</p>
                }
                <div className="flex justify-end gap-2 pt-2 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="outline"
                        color="blue"
                        label="Annulla"
                        disabled={isLoading}
                        onClick={onClose}
                    />
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="red"
                        label="Elimina"
                        disabled={isLoading || !id}
                        onClick={() => {
                            if (!id) return;
                            dispatch(removeCompanyCenter(id));
                        }}
                    />
                </div>
            </div>
        </PopupForm>
    );
}
